import { NavigationContainerRefWithCurrent } from '@react-navigation/native'
import { useAuthentication } from 'authentication/context'
import { CalendarSyncProvider } from 'calendar_sync/context'
import { CustomGroupProvider } from 'chat/conversations/group/context'
import { MemberListProgressProvider } from 'chat/members/progress_context'
import { MessagingProvider } from 'chat/messaging_context'
import { RefetchMessagingProvider } from 'chat/refetch_messaging_context'
import { SendMessageProvider } from 'chat/send_message_context'
import { ChatWebsocketProvider } from 'chat/websocket/context'
import { CompaniesProvider } from 'company/context'
import { ShareResourceProvider } from 'file_folder_repository/chat_group_folders/send_file_folders/context'
import { FileFolderActionsProvider } from 'file_folder_repository/context'
import { FreshchatProvider } from 'freshchat/service/context'
import { HomeStack } from 'home/stack'
import { AddEditUserProvider } from 'management_team/context'
import { ManagementTeamActionsProvider } from 'management_team/management_actions_context'
import { PushNotificationsProvider } from 'notifications/push_notifications_context'
import { WebNotificationsProvider } from 'notifications/web_notifications_context'
import { OnboardingProvider } from 'onboarding/service/context'
import { OnboardingStack } from 'onboarding/stack'
import React from 'react'
import { MenuProvider } from 'react-native-popup-menu'
import { FilterProvider } from 'schedule/filters/context'
import { ScheduleProvider } from 'schedule/schedule_context'
import { ShiftActionsProvider } from 'shifts/shift_actions_context'
import { RecentStoresProvider } from 'stores/context'
import { AddEditTaskProvider } from 'tasks/context'
import { UserAnalyticsLayer } from 'users/user_analytics_layer'
import { ConceptDataHandler } from './concept_data_handler'
import { useServerLanguageSync } from './locale_sync'
import { RoutingProvider } from './routing_context'
import { AppParamList } from './types'

export default function Root({
  navigationRef,
}: {
  navigationRef: NavigationContainerRefWithCurrent<AppParamList>
}) {
  const { status: authStatus } = useAuthentication()
  const loggedIn = authStatus === 'loggedIn'

  useServerLanguageSync(loggedIn)

  if (loggedIn) {
    return (
      <MessagingProvider>
        <ConceptDataHandler>
          <RecentStoresProvider>
            <CompaniesProvider>
              <MemberListProgressProvider>
                <RefetchMessagingProvider>
                  <UserAnalyticsLayer>
                    <ChatWebsocketProvider>
                      <MenuProvider>
                        <CustomGroupProvider>
                          <FilterProvider>
                            <CalendarSyncProvider>
                              <ScheduleProvider>
                                <RoutingProvider navigationRef={navigationRef}>
                                  <ShiftActionsProvider>
                                    <FreshchatProvider>
                                      <AddEditUserProvider>
                                        <AddEditTaskProvider>
                                          <ManagementTeamActionsProvider>
                                            <PushNotificationsProvider>
                                              <WebNotificationsProvider>
                                                <SendMessageProvider>
                                                  <ShareResourceProvider>
                                                    <FileFolderActionsProvider>
                                                      <HomeStack
                                                        navigationRef={
                                                          navigationRef
                                                        }
                                                      />
                                                    </FileFolderActionsProvider>
                                                  </ShareResourceProvider>
                                                </SendMessageProvider>
                                              </WebNotificationsProvider>
                                            </PushNotificationsProvider>
                                          </ManagementTeamActionsProvider>
                                        </AddEditTaskProvider>
                                      </AddEditUserProvider>
                                    </FreshchatProvider>
                                  </ShiftActionsProvider>
                                </RoutingProvider>
                              </ScheduleProvider>
                            </CalendarSyncProvider>
                          </FilterProvider>
                        </CustomGroupProvider>
                      </MenuProvider>
                    </ChatWebsocketProvider>
                  </UserAnalyticsLayer>
                </RefetchMessagingProvider>
              </MemberListProgressProvider>
            </CompaniesProvider>
          </RecentStoresProvider>
        </ConceptDataHandler>
      </MessagingProvider>
    )
  }

  return (
    <OnboardingProvider>
      <OnboardingStack />
    </OnboardingProvider>
  )
}
